import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#D4AF37]/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-14 h-14 flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_learn-finance-5/artifacts/u8xwnrlt_Logo_Geldgymnasium_riesig.png" 
                alt="GeldGymnasium Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-[#D4AF37] to-[#B8960C] bg-clip-text text-transparent">
                GeldGymnasium
              </h1>
              <p className="text-xs text-gray-600">Finanzielle Bildung</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('courses')}
              className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium"
            >
              Termine
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium"
            >
              Über Uns
            </button>
            <div className="ml-4">
              <Button
                onClick={() => scrollToSection('courses')}
                className="bg-gradient-to-r from-[#D4AF37] to-[#FFD700] hover:from-[#B8960C] hover:to-[#D4AF37] text-white shadow-lg transition-all duration-300 hover:shadow-xl"
              >
                Jetzt Buchen
              </Button>
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-700 hover:text-[#D4AF37] transition-colors"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#D4AF37]/20">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('hero')}
                className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium text-left"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('courses')}
                className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium text-left"
              >
                Termine
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-[#D4AF37] transition-colors font-medium text-left"
              >
                Über Uns
              </button>
              <Button
                onClick={() => scrollToSection('courses')}
                className="bg-gradient-to-r from-[#D4AF37] to-[#FFD700] hover:from-[#B8960C] hover:to-[#D4AF37] text-white"
              >
                Jetzt Buchen
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};